const API_URL = process.env.REACT_API_URL || "https://sinfoniaservices-collaudo.regione.campania.it/mmg/";
//const API_URL = process.env.REACT_API_URL || "http://localhost:3001/api/"; //FOR LOCAL DEV
const IS_DEV = process.env.REACT_APP_IS_DEV === "true";
const TEST_FISCAL_CODE = process.env.REACT_APP_TEST_FISCAL_CODE;
const FAQ_URL =
  process.env.REACT_APP_FAQ_URL || "https://sinfoniaservices-collaudo.regione.campania.it/fseplus/faq?servizio=SER";
const SKIP_CHANGE_MMG_API = process.env.REACT_APP_SKIP_CHANGE_MMG_API === "true";

export { API_URL, IS_DEV, TEST_FISCAL_CODE, FAQ_URL, SKIP_CHANGE_MMG_API };
